export const normalizeChatData = (chats) => {
    let chatData = {};

    for (let chat of chats) {
        chatData[chat.Id] = { ...chat };
    }

    return { chatData };
};
